module.exports = __webpack_public_path__ + "img/Frame 718.3d18c6cf.png";